import { Point } from './point.model';
import { AnalysisService } from 'app/services/analysis.service';

declare var google: any;

export class RoofModel {

  // oznaczenie kierunku spadku
  dirStart: google.maps.LatLng;
  dirEnd: google.maps.LatLng;
  // arrow
  line: google.maps.Polyline;


  overlay: any;
  // vertical angle
  angleV: number;
  // horizontal orientation angle
  angleH: number;
  // horizontal orientation name
  angleHLabel: string;
  // powierzchnia dachu
  area: number;
  // rzeczywiste nasłonecznienienie
  I_gr: number;
  // współczynnik mocy promieniowania słonecznego
  powerMax: number;
  // nasłonecznienie
  I_g: number;
  // usłonecznienie0
  uslonecznienie: number;


  constructor(o: any, v: number, h: number, hLabel: string) {
    this.overlay = o;
    this.angleH = h;
    this.angleV = v;
    this.angleHLabel = hLabel;


  };

  calculateValues() {
    const aH = this.angleH * (Math.PI / 180) - Math.PI;
    const aV = this.angleV * (Math.PI / 180);
    const a35 = 35 * (Math.PI / 180);

    this.I_gr = this.I_g * Math.cos(aH / 2.71) * Math.cos(aV - a35);
    this.powerMax = this.I_gr * this.area;
  }

  updateRoof(analysisService: AnalysisService) {
    this.area = analysisService.computeArea(this.overlay.getPath());
    const loc = this.overlay.getPath().getAt(0);
    this.uslonecznienie = analysisService.calcInsFor(loc.lat(), loc.lng());
    this.I_g = analysisService.calcI_gFor(loc.lat(), loc.lng());
    this.calculateValues();
  }

  calcAngle() {
    if (this.dirStart && this.dirEnd) {
      const x = this.dirEnd.lng() - this.dirStart.lng();
      const y = this.dirEnd.lat() - this.dirStart.lat();
      const rad = Math.abs(Math.atan(x / y));
      let stopnie = (180 * rad) / Math.PI;
      if (y < 0) {
        stopnie = 180 - stopnie;
      }
      this.angleH = stopnie;
    }
  }

  drawArrow(map: any) {
    this.deleteArrow();
    const lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    };

    this.line = new google.maps.Polyline({
      path: [this.dirStart, this.dirEnd],
      icons: [{
        icon: lineSymbol,
        offset: '100%'
      }],
      strokeColor: '#000000',
      zIndex: 6,
      map: map
    });
  }

  setArrowPoints(p: google.maps.LatLng, map: any) {
    if (!this.dirStart) {
      this.dirStart = p;
    } else {
      this.dirEnd = p;
      // oblicz angle
      this.calcAngle();
      // draw an arrow
      this.drawArrow(map);
      console.log('Kierunek dachu: ', this.angleH);
    }
  }

  deleteArrow() {
    if (this.line) {
      this.line.setMap(null);
      this.line = null;
    }
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/model/roof.model.ts